import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { LOAN_SECTION_KEYS } from "../loan.constants";

import { rows } from "./section-loan-partial-release-rows";

const nullData = {
  stylename: "Work Sans /  16 Regular",
  fontFamily: "Work Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "center",
  textColor: "#7d8084"
};

export class LoanPartialRelease extends Component {
  drawDataPartialRelease(data) {
    if (data.covenants) {
      if (data.covenants.maximumRelease ||
        data.covenants.allocations ||
        data.covenants.notice ||
        data.covenants.conditions ||
        data.covenants.partialReleaseMisc) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={data} />;
      }

      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  render() {
    const { data, history, loanId, enableEditButton, eventHandlers, ...other } = this.props;
    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Partial Release",
            key: LOAN_SECTION_KEYS.PARTIAL_RELEASE,
            isTitleGroup: true,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.PARTIAL_RELEASE}`),
            sections: [
              this.drawDataPartialRelease(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.partialrelease.header",
            referenceStyles: { marginLeft: "20px" }
          }
        ]}
      />
    );
  }
}
